export const GENERAL_VENDOR_LIST = "GENERAL_VENDOR_LIST";
export const FOOTER = "FOOTER";
